import React, { useState, useEffect } from 'react';
import './nftForm.css';
import styles from './nftInfo.module.css';
import axios from 'axios';
import config from '../../../../config/environment';


export default function NftsForm (props) {
    const { textCont, val1, val2, val3, val4, updateTable, curCode } = props

    const [infoState, setInfoState] = useState({
        currencyCode: "",
        contractAddress: "",
        contractName: "",
        contractSymbol: "",
        contractImage: "",
        contractDescription: ""
    });

    const [errorInfoState, setErrorInfoState] = useState({
        errorCurrencyCode: false,
        errorContractAddress: false,
        errorContractName: false,
        errorContractSymbol: false,
        errorContractImage: false,
        errorContractDescription: false
    });

    useEffect(() => {
        setInfoState({
            ...infoState,
            contractAddress: textCont,
            contractName: val1 || "",
            contractSymbol: val2 || "",
            contractImage: val3 || "",
            contractDescription: val4 || "",
            currencyCode: curCode || "DEFAULT"
        })
    }, []);

    const handleSubmit = () => {
        if(infoState.currencyCode === "DEFAULT" || !infoState.currencyCode){
            setErrorInfoState(errorInfoState =>{return{
                ...errorInfoState,
                errorCurrencyCode: true
            }})

            return
        }

        if(!infoState.contractAddress){
            setErrorInfoState(errorInfoState =>{return{
                ...errorInfoState,
                errorContractAddress: true
            }})

            return
        }

        const reqBody = JSON.parse(JSON.stringify(infoState));

        for (const [key, value] of Object.entries(infoState)) {
            if (!value) {
                delete reqBody[key]
            }
        }
        
        try {
            axios.post(config.backendUrl + "/micro-trustee/update-contract-info",
            reqBody, {
                headers: {
                    'Authorization': 'Bearer ' + localStorage.getItem('jwtToken')
                }
            }).then(()=>{
                updateTable()
                alert("SUCCESS")
            }).catch(e => {
                alert(e.response.data.message)
            })
        } catch(e) {
            alert(e.response.data.message)
        }
    };


    const currencyCodeChange = (e) => {
        setInfoState({
            ...infoState,
            currencyCode: e.target.value
        })
        setErrorInfoState({
            ...errorInfoState,
            errorCurrencyCode: false
        })
    };

    const contractAddressChange = (e) => {
        setInfoState({
            ...infoState,
            contractAddress: e.target.value
        })

        setErrorInfoState({
            ...errorInfoState,
            errorContractAddress: false
        })
    };

    const contractNameChange = (e) => {
        setInfoState({
            ...infoState,
            contractName: e.target.value
        })
    };

    const contractSymbolChange = (e) => {
        setInfoState({
            ...infoState,
            contractSymbol: e.target.value
        })
    };

    const contractImageChange = (e) => {
        setInfoState({
            ...infoState,
            contractImage: e.target.value
        })
    };

    const contractDescriptionChange = (e) => {
        setInfoState({
            ...infoState,
            contractDescription: e.target.value
        })
    };

    return(
        <>
            <div className = "nftForm_wrapper">
                <select onChange={currencyCodeChange} className={styles.select_network_item_modal} style={errorInfoState.errorCurrencyCode ? {border: "3px solid red"} : {border: "1px solid #1F082B"}}>
                    <option selected={infoState.currencyCode === "DEFAULT"} value="DEFAULT">Select the network</option>
                    <option selected={infoState.currencyCode === "BNB"} value="BNB">BNB</option>
                    <option selected={infoState.currencyCode === "MATIC"} value="MATIC">MATIC</option>
                    <option selected={infoState.currencyCode === "ONE"} value="ONE">ONE</option>
                </select>
                <textarea value={infoState.contractAddress} onChange={contractAddressChange} style={errorInfoState.errorContractAddress ? {border: "3px solid red"} : {border: "1px solid #1F082B"}} className={styles.input_select_network_area} type="text" placeholder='Contract Address'/>
                <input value={infoState.contractName} onChange={contractNameChange} className={styles.input_select_network} type="text" placeholder='Contract name (optional)'/>
                <input value={infoState.contractSymbol} onChange={contractSymbolChange} className={styles.input_select_network} type="text" placeholder='Contract symbol (optional)'/>
                <textarea value={infoState.contractImage} onChange={contractImageChange} className={styles.input_select_network_area} type="text" placeholder='Contract picture link (optional)'/>
                <textarea value={infoState.contractDescription} onChange={contractDescriptionChange} className={styles.input_select_network_area} type="text" placeholder='Contract description (optional)'/>
                <button onClick={handleSubmit} className={styles.submit_btn} type='submit'>Submit</button>
            </div>
        </>
    )
}